import React from "react";
import AccountDetailLayout from "./AccountDetailLayout";
import MessageSidebar from "./MessageSidebar";
import SideADModule from "../../containers/PostCards/SideADModule";

const MainSection = () => (
  <section className={`binduz-er-trending-area `}>
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <AccountDetailLayout />
        </div>
        {/* <div className="col-lg-3 col-md-12">
        
          <SideADModule  isEvent={true} />
        </div> */}
      </div>
    </div>
  </section>
);

export default MainSection;
